import { render, staticRenderFns } from "./SpinFlaticonButtons.vue?vue&type=template&id=4acb2a17&scoped=true&"
import script from "./SpinFlaticonButtons.vue?vue&type=script&lang=js&"
export * from "./SpinFlaticonButtons.vue?vue&type=script&lang=js&"
import style0 from "./SpinFlaticonButtons.vue?vue&type=style&index=0&id=4acb2a17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb2a17",
  null
  
)

export default component.exports